import { TileBase } from "./TileBase";
import { Game, eModelAsset, eSfxSprite, SfxSprites, eAudioAsset } from "../../../Game";
import { TIMER } from "../../Gameplay";
import { Player } from "../Player/Player";
import { ViewCellMap } from "../View/ViewCellMap";
import { eTileType, MapCell } from "../Game Map/MapCell";
import { ViewCellMapCell } from "../View/ViewCellMapCell";
import { SoundManager } from "../../../Utils/SoundManager";



/**
 * Dlazdice, ktera se po kolizi s hracem rozpadne
 */
export class FragileTile extends TileBase {
    private static MODEL_ASSET: pc.Asset;

    private static readonly FLAG_DECAY1 = 0x00010000;
    private static readonly FLAG_DECAY2 = 0x00020000;

    private _decayStartTime: number;
    private _overlay: pc.MeshInstance;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        if (!FragileTile.MODEL_ASSET)
            FragileTile.MODEL_ASSET = Game.app.assets.find(eModelAsset.tileFragile_0, pc.ASSET_MODEL);

        super(eTileType.fragile);

        this._entity.model.asset = FragileTile.MODEL_ASSET;
        this._overlay = this._entity.model.meshInstances[0];
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(cell: ViewCellMapCell, cellData: MapCell): void {
        super.init(cell, cellData);
        this._overlay.visible = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if ((this._flags & (FragileTile.FLAG_DECAY1 | FragileTile.FLAG_DECAY2)) != 0) {
            let progress = (TIMER.time - this._decayStartTime) / 500;

            if ((this._flags & FragileTile.FLAG_DECAY1) != 0 && progress > 0.2) {
                this._flags &= ~(FragileTile.FLAG_DECAY1 | TileBase.FLAG_GROUND);
                this._flags |= FragileTile.FLAG_DECAY2;
            }

            if (progress > 1)
                progress = 1;

            let pos = this._entity.getLocalPosition();

            pos.y = -4 * pc.CubicIn(progress);
            this._entity.setLocalPosition(pos);

            if (progress == 1) {
                this._flags &= ~FragileTile.FLAG_DECAY2;
                this.release();
                return false;
            }
        }

        return true;
    }

    //-------------------------------------------------------------------------
    /**
     * Zpracovat kolizi s hracem
     */
    //-------------------------------------------------------------------------
    handleCollision(player: Player): boolean {
        if ((this._flags & TileBase.FLAG_HANDLE_COLLISION) != 0) {
            this._flags &= ~TileBase.FLAG_HANDLE_COLLISION;
            this._flags |= FragileTile.FLAG_DECAY1;
            this._decayStartTime = TIMER.time;

            // Aktivovat dlazdici
            this._overlay.visible = true;
            ViewCellMap.instance.addTileToActList(this);

            return true;
        }

        return false;
    }
}